export default "__VITE_ASSET__DO3CFkfu__"